import { SxProps } from "@mui/material";

export const BLUE_500 = "#0055A4";
export const GRAY_200 = "#E4E7EC";

import { commonStyles } from "../../tokens";
export const cardBoxSx = commonStyles.stepCard;

export const radioSx: SxProps = {
  color: BLUE_500,
  "&.Mui-checked": { color: BLUE_500 },
};

export const optionTextSx: SxProps = {
  color: "#465869",
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.5px",
  fontWeight: 400,
};
